import { FC, useState } from "react";
import classNames from "classnames";
import OutsideClickHandler from "../OutsideClickHandler/OutsideClickHandler";

import { CloseIcon, PlusIcon } from "../icons";
import Button from "../Button/Button";
import Title from "../Title/Title";
import { TitleWithFormProps } from "./types";
import { AddForm } from "../index";
import { AddFormItem } from "../AddForm/types";
import { mapToAddFormItem } from "../AddForm/utils/mapToAddFormItem";

import styles from "./TitleWithForm.module.css";



const TitleWithForm: FC<TitleWithFormProps> = ({
  label,
  className,
  onAddItem,
  placeholder,
  onInput,
  onFocus,
  onOutsideClick,
  value,
}) => {
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [searchValue, setSearchValue] = useState<AddFormItem>(mapToAddFormItem(''));

  const handleOpenAddCompetitors = () => {
    setIsOpenForm(!isOpenForm);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onInput) {
      onInput(mapToAddFormItem(e.target.value));
    } else {
      setSearchValue(mapToAddFormItem(e.target.value));
    }
  };

  const handleAddItem = (item: AddFormItem) => {
    onAddItem(item);

    if (onInput) {
      onInput(mapToAddFormItem(''));
    } else {
      setSearchValue(mapToAddFormItem(''));
    }

    setIsOpenForm(false);
  };

  return (
    <>
      <a className={classNames(styles["title"], className)} >
        <Button
          className={styles["title__icon"]}
          typeStyle="round"
          Icon={PlusIcon}
          onClick={handleOpenAddCompetitors}
        />
        <Title label={label} />
        {isOpenForm &&
          <Button
            className={styles["title__icon-close"]}
            typeStyle="empty"
            Icon={CloseIcon}
            onClick={handleOpenAddCompetitors}
          />
        }
      </a>

      {isOpenForm &&
        <OutsideClickHandler onOutsideClick={(e) => {
          if (onOutsideClick) {
            onOutsideClick(e);
          }
        }}>
          <AddForm
            value={value || searchValue}
            onFocus={onFocus}
            onChange={handleInputChange}
            onAddItem={handleAddItem}
            placeholder={placeholder}
          />
        </OutsideClickHandler>
      }
    </>

  );
};

export default TitleWithForm;